<template>
  <div>
    <chat-window
      :current-user-id="currentUserId"
      :rooms="[
          {
            roomId: 1,
            roomName: contactUsForm.user_name,
            users: [
              {
                _id: contactUsForm.user_code,
                username: contactUsForm.user_name
              },
              {
                _id: currentUserId,
                username: 'Admin Isikulkas',
              },
              {
                _id: 12,
                username: 'Dummy',
              }
            ],
            typingUsers: [ currentUserId ]
          }
        ]"
      :messages="messages"
      :loadingRooms="loadingRooms"
      :messagesLoaded="messagesLoaded"
      @send-message="sendMessage"
    >
    </chat-window>

    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import Loading from "../../../../templates/Loading";
import GlobalTable from "../../../../templates/Table";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";

import ChatWindow from 'vue-advanced-chat'
import 'vue-advanced-chat/dist/vue-advanced-chat.css'

export default {
  name: "Respond_Chat",
  components: { GlobalTable, Loading, ChatWindow },
  data() {
    return {
      title: "Respond Chat",
      activeTab: 0,
      items: [],
      route:"",
      ticketNumber:"",
      contactUsDiscussion: [],
      contactUsStatusList:[],
      contactUsForm: tableInterfaces.contact_us,
      contactUsDiscussionForm: tableInterfaces.contact_us_discussion,
      isLoading: false,
      activeTab: 0,
      content: '',
      editorOption: {},
      rooms: [],
      loadingRooms: true,
      messages: [],
      messagesLoaded: false,
      currentUserId: 11,
			roomId: 1
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },

  methods: {
    init: function (id) {
      this.getDetailIssue(id);
    },
    resetForm: function () {
      for (var i in tableInterfaces.contact_us) {
        tableInterfaces.contact_us[i] = null;
      }
      this.contactUsForm = tableInterfaces.contact_us;
    },
    getDetailIssue: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/master/contact_us/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.contactUsForm = response.data.data;
            // console.log(response.data.data);
            //this.contactUsForm.user_code = response.data.data.user_name;
            this.contactUsDiscussion = response.data.dataDetail;
            this.contactUsStatusList = response.data.contact_us_status;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getResponse(route){
      this.isLoading = true;

      this.axios
      .get("console/master/contact_us/detail/"+route)
      .then((response) => {
        if (response.data.status === 2000) {
          // console.log(response.data.data)
          let data_detail = [],
              date_full = new Date(response.data.data.date_inserted),
              data_date = '',
              datemonth= date_full.getMonth()+1,
              dateday= date_full.getDate(),
              datehours= date_full.getHours(),
              dateminutes= date_full.getMinutes(),
              the_code='',
              the_name='',
              data_full ='',
              monthName = ['no','January','Febuary','March','April','May','June','July','August','September','October','November','December'],
              array_dataDetail = response.data.dataDetail;
          
          //set current user name
          the_name = response.data.data.user_name
          the_code = response.data.data.user_code

          if(datehours < 10){
            datehours = '0'+date_full.getHours();
          }

          if(dateminutes < 10){
            dateminutes = '0'+date_full.getMinutes();
          }

          if(dateday < 10){
            dateday = '0'+date_full.getDate();
          }
          
          data_full = dateday+' '+monthName[datemonth]+' '+date_full.getFullYear();
          data_date = datehours+':'+dateminutes;

          data_detail.push({
            _id: 1,
            roomId: this.roomId,
            content: response.data.data.messages,
            senderId: response.data.data.user_code,
            username: response.data.data.user_name,
            date: data_full,
            timestamp: data_date,
            seen: true,
            disableActions: true,
            disableReactions: true
          })

          this.ticketNumber=response.data.data.ticket_number;

          //console.log(response.data.data)              
          let i = 1,
              the_id='',
              username='';

          array_dataDetail.forEach(function(respontambah){
            // console.log(respontambah)
            i++;

            date_full = new Date(respontambah.date_inserted);
            datehours = date_full.getHours(),
            dateminutes = date_full.getMinutes(),
            datemonth=date_full.getMonth()+1,
            dateday=date_full.getDate();
            
            if(datehours < 10){
              datehours = '0'+datehours;
            }

            if(dateminutes < 10){
              dateminutes = '0'+dateminutes;
            }

            if(dateday < 10){
              dateday = '0'+dateday;
            }

            //Check user code
            if(respontambah.response_by_agent !== null || respontambah.response_by_admin !== null){
              the_id = 11;
            }else{
              the_id = respontambah.response_by
            }

            if(respontambah.response_by === the_code){
              username = the_name;
            }else{
              username = 'Admin'
            }

            data_full = dateday+' '+monthName[datemonth]+' '+date_full.getFullYear();
            data_date = datehours+':'+dateminutes;

            data_detail.push({
              _id: i,
              roomId: 1,
              content: respontambah.messages,
              senderId: the_id,
              username: username,
              date: data_full,
              timestamp: data_date,
              seen: true,
              disableActions: true,
              disableReactions: true
            })
          })

          this.messages=data_detail;

          // console.log(this.messages)
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message,
          });
        }
      })
      .catch((error) => {
        this.showErrorNotification({
          title: this.title,
          message: error,
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    async sendMessage({ content, roomId, files, replyMessage }) {
      this.isLoading = true;
      
			const message = {
        ticket_number: this.ticketNumber,
				messages: content
			}

      this.axios
      .post("console/master/contact_us/add-response-chat", message)
      .then((response) => {
        if (response.data.status === 2000) {
          // console.log(response)
          this.showInfoNotification({
            title: this.title,
            message: response.data.message,
          });
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message,
          });
        }
      })
      .catch((error) => {
        this.showErrorNotification({
          title: this.title,
          message: error,
        });
      })
      .finally(() => {
        this.isLoading = false;
        this.init(this.route);
        this.getResponse(this.route)
        this.loadingRooms = false
        this.messagesLoaded = true
      });
		},
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
    this.getResponse(route[4])
    this.route = route[4]
    this.loadingRooms = false
    this.messagesLoaded = true
  },
};
</script>

<style>
.vac-rooms-container.vac-app-border-r,
.vac-room-wrapper .vac-svg-button.vac-toggle-button,
.vac-box-footer > .vac-icon-textarea-left,
.vac-box-footer > .vac-icon-textarea > .vac-wrapper,
.vac-box-footer > .vac-icon-textarea > .vac-svg-button:nth-child(2){
  display:none;
}
.vac-card-window{
  height:380px !important;
}
</style>
